import { format, isValid } from "date-fns";
import { recurringDays, formatPrice } from 'utils';

export const exportFileName = ({ startDate, endDate, status, report }) => {
  let dates = `${format(startDate, "MM/dd/yyyy")}_${format(endDate, "MM/dd/yyyy")}`;

  return report ? `report_inspections_${dates}` : `${status}_inspections_${dates}`;
}

export const csvData = ({ status, inspections, report }) => {
  const headers = {
    open: ['Name', 'Property', 'Cost', 'Created By', 'Assigned', 'Date Created', 'Due Date', 'Progress'],
    completed: ['Name', 'Property', 'Cost', 'Created By', 'Assigned', 'Date Created', 'Date Completed', 'Progress'],
    cancelled: ['Name', 'Property', 'Cost', 'Created By', 'Assigned', 'Date Created', 'Date Canceled', 'Progress'],
    recurring: ['Name', 'Property', 'Created By', 'Assigned', 'Date Created', 'Recurs']
  }

  let data = [];

  inspections.map(inspection => {
    let inspectionData = [
      `${inspection.template} ${inspection.unit ? `- ${inspection.unit}` : ''}`,
      `${inspection.property}`,
    ];

    if (!report && status !== 'recurring') {
      inspectionData.push(inspection.has_charges && inspection.total_cost_in_cents !== null ? `$${formatPrice((inspection.total_cost_in_cents / 100), true)}` : '-')
    }
    if (report) {
      inspectionData.push(inspection.has_charges && inspection.total_cost_in_cents !== null ? `$${formatPrice((inspection.total_cost_in_cents / 100), true)}` : '-')
    }

    inspectionData.push(`${inspection.created_by}`);
    inspectionData.push(`${inspection.assigned_to ?? 'Unassigned'}`);
    inspectionData.push(`${format(inspection.creation_date, 'MM/dd/yyyy')}`);

    if (!report && status === 'open') {
      inspectionData.push(`${inspection.due_date ? format(new Date(inspection.due_date), 'MM/dd/yyyy') : ''}`);
    }

    if (!report && status === 'completed') {
      inspectionData.push(`${inspection.completion_date ? format(inspection.completion_date, 'MM/dd/yyyy') : ''}`);
    }
    if (!report && status === 'cancelled') {
      inspectionData.push(`${inspection.cancellation_date ? format(inspection.cancellation_date, 'MM/dd/yyyy') : ''}`);
    }
    if (!report && status !== 'recurring') {
      inspectionData.push(`completed ${inspection.started_items + inspection.completed_items} out of ${inspection.num_items}`);
    } else if (!report) {
      inspectionData.push(`${recurringDays(inspection.schedule)}`);
    }
    if (report) {
      inspectionData.push(`${inspection.status}`);
    }

    data.push(inspectionData);
  })

  return [report ? ['Name', 'Property', 'Cost', 'Created By', 'Assigned', 'Date Created', 'Status'] : headers[status] ?? []].concat(data);
}
